import CustomEvents, { Events } from "venuescanner-js/services/windowEvents";
class User {
  constructor(data = {}) {
    this._data = {};
    Object.keys(data).forEach((k) => {
      this._data[k] = data[k];
      Object.defineProperty(this, k, {
        get: function () {
          return this._data[k];
        },
        set: function (v) {
          this._data[k] = v;
        },
      });
    });
  }
}
const pageUser = {
  user: null,
  init: function () {
    if (window && window.data && window.data.user && window.data.user._id) {
      this.user = new User(window.data.user);
    } else {
      CustomEvents.on(Events.loggedIn, (event, data) => {
        if (window && window.data && window.data.user && window.data.user._id) {
          this.user = new User(window.data.user);
        }
      });
    }
  },
};
pageUser.init();
window.pageUser = pageUser;
export default pageUser;
